import axios from 'axios';
import { getQueryClient } from '@queries/QueryClientWrapper';
import { environment } from '@environments/environment';
import { ProductsParam, TrendsKpi } from '@models/Products';
import { constructRequest } from '@utils/serviceUtils/RequestFormatter';
import { RequestPayloadArgumentObject } from '@pages/product-analyzer/Product';
import { throwApiError } from '@services/utils/ErrorHandlers';

export const getProductsTrends = async (param: ProductsParam): Promise<TrendsKpi> => {
  let body: any;
  try {
    const qc = getQueryClient('products');

    const payload: RequestPayloadArgumentObject = {
      clientId: param.clientId,
      productType: param.productType,
      countryId: [param.countryId],
      productGroup: param.productGroup,
      periodType: param.periodType,
      period: param.period,
      comparisonPeriod: param.comparisonPeriod,
      appliedFilters: param.appliedFilters,
      kpi: param.kpi,
      calculateRollingPeriod: true,
      isMarket: param.isMarket,
      page: undefined,
      size: undefined,
      sortBy: param.sortingKpi,
      sortDirection: 'desc',
      sortKey: 'ABSOLUTE',
      comparisonGrowth: undefined,
    };

    const queryKey = ['products-trends', payload] as const;
    const url = `${environment.baseUrl}/v2/products/trends`;
    body = constructRequest(payload);

    return await qc.ensureQueryData<TrendsKpi>({
      queryKey,
      queryFn: async ({ signal }) => {
        const { data } = await axios.post<TrendsKpi>(url, body, { signal });
        return data;
      },
    });
  } catch (err: any) {
    // Delegated error handling; helper always throws. Added explicit throw for Sonar compliance.
    throwApiError(err, { excludedBrand: body?.excludedBrand }); // NOSONAR
  }
};
